import React from 'react';

import {useRemainingSticksEnabled} from '@/hooks/useDeviceSettingsEnabled';
import appContent from '@/services/content/appContent';
import {formatString} from '@/utils/stringUtils';

import RemainingSticksInfoIcon from './RemainingSticksInfoIcon';
import useRemainingSticks from './useRemainingSticks';

const RemainingSticksInfo = () => {
    const remainingSticks = useRemainingSticks();
    const isRemainingSticksEnabled = useRemainingSticksEnabled();

    const isRemainingSticksVisible = remainingSticks !== null;

    if (!isRemainingSticksEnabled || !isRemainingSticksVisible) return null;

    const {remainingSticksTitle} = appContent.getDeviceStatusContent();

    return (
        <div className='flex items-center gap-1.5'>
            <div className='h-6 w-0.5 rounded-sm bg-mischka' />
            <p className='text-14 font-bold tracking-02 text-black'>
                {formatString(remainingSticksTitle, remainingSticks)}
            </p>
            <RemainingSticksInfoIcon />
        </div>
    );
};

export default RemainingSticksInfo;
